// src/blog/renderBlogView.ts
import { getBaseUrl } from "../utils/config";
import { applyFormatting } from "utils/formatting";

const BASE_URL = getBaseUrl();

export function renderBlogView(sections: { attrs: Record<string, any>, content: string }[]): void {
  const wrapper = document.getElementById("scroll-wrapper");
  if (!wrapper) return;

  // Enable blog scroll styling
  document.documentElement.classList.add("blog-mode");
  document.body.classList.add("blog-mode");

  wrapper.innerHTML = "";
  wrapper.className = "container my-5 blog-wrapper";

  sections.forEach(({ attrs, content }, index) => {
    const article = document.createElement("article");
    article.className = "mb-5 pb-4 border-bottom";

    // Optional: Hero image
    if (index === 0 && attrs.background) {
      const img = document.createElement("img");
      img.src = `${BASE_URL}/images/${attrs.background}`;
      img.alt = "Header Image";
      img.className = "img-fluid mb-3 rounded shadow hero-image";
      article.appendChild(img);
    }

    const lines = content.split("\n");

    // Optional: Multi-line Hero title
    if (index === 0) {
      const titleLines: string[] = [];
      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed || trimmed.startsWith("::") || trimmed.startsWith("@@")) break;
        if (trimmed.startsWith("#!")) {
          titleLines.push(trimmed.replace(/^#!\s*/, ""));
        } else {
          titleLines.push(trimmed);
        }
      }

      if (titleLines.length > 0) {
        const title = document.createElement("h1");
        title.innerText = cleanLine(titleLines.join(" "));
        title.className = "display-4 fw-bold mb-3";
        article.appendChild(title);
      }
    }

    lines.forEach(line => {
      const trimmed = line.trim();
      if (!trimmed || trimmed.startsWith("::space:")) return;

      // Skip special directives
      if (trimmed.startsWith("::") || trimmed.startsWith("@@") || trimmed.startsWith("***")) return;

      if (trimmed.startsWith("::image:")) {
        const file = trimmed.replace("::image:", "").trim();
        const img = document.createElement("img");
        img.src = `${BASE_URL}/images/${file}`;
        img.alt = file.split("/").pop() || "Blog image";
        img.className = "img-fluid my-3 rounded";
        article.appendChild(img);
        return;
      }

      // Parse anim markup
      const cleaned = cleanLine(trimmed);

      // Headings
      const headingMatch = cleaned.match(/^(#+!?)(.*)/);
      if (headingMatch) {
        const [, hashes, text] = headingMatch;
        const level = Math.min(hashes.replace("!", "").length, 6);
        const h = document.createElement(`h${level}`);
        h.innerHTML = applyFormatting(text.trim());
        h.className = "mt-4 mb-2 fw-semibold";
        article.appendChild(h);
        return;
      }

      // Paragraph
      const p = document.createElement("p");
      p.innerHTML = applyFormatting(cleaned);
      p.className = "mb-3";
      article.appendChild(p);
    });

    wrapper.appendChild(article);
  });
}

// Strip ^^markup^^(1.2, anim) from line content
function cleanLine(input: string): string {
  return input.replace(/\^\^(.*?)\^\^\([^)]+\)/g, '$1');
}